"use strict";

import {findAll, on, closest, addClass, removeClass, findIn} from '@elements/dom-utils';
import {onFind} from '@elements/init-modules-in-scope';

export function init() {
    onFind('.js-filter', filter => {
        let button = findIn('.js-filter__button-filter', filter);
        let close = findIn('.js-filter__button-close', filter);
        let cancel = findIn('.js-filter__button-cancel', filter);
        let save = findIn('.js-filter__button-save', filter);
        let filterOverlay = findIn('.js-filter__overlay', filter);

        on('click', (e) => {
            addClass('is-active', filterOverlay);
        }, button);

        on('click', (e) => {
            removeClass('is-active', filterOverlay);
        }, close);

        on('click', (e) => {
            removeClass('is-active', filterOverlay);
        }, cancel);


        on('click', (e) => {
            removeClass('is-active', filterOverlay);
        }, save);
    });
}